import { UnderlinedSectionTitle } from "@/features/home/components/UnderlinedSectionTitle";

import { BlogPost } from "../type";
import { SideBlogItem } from "./SideBlogItem";

type SideBlogListProps = {
  blogPosts: BlogPost[];
};

export function SideBlogList({ blogPosts }: SideBlogListProps) {
  return (
    <div>
      <UnderlinedSectionTitle titleProps={{ size: "h4" }}>
        更多文章
      </UnderlinedSectionTitle>

      <div className="py-2">
        {blogPosts.map((blogPost) => (
          <SideBlogItem key={blogPost.id} blogPost={blogPost} />
        ))}
      </div>
    </div>
  );
}
